var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"w-down",class:_vm.cls,attrs:{"href":_vm.url},on:{"click":_vm.doDown}},[_c('i',{staticClass:"el-icon-download"}),(!_vm.$slots.default)?_c('span',{staticClass:"u-text"},[_vm._v("下载")]):_vm._e(),_vm._t("default"),(_vm.showCount)?_c('span',{staticClass:"u-count"},[_vm._v(_vm._s(_vm.total))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }